
import React from 'react';
import { Story } from '@/utils/storiesData';
import VimeoPlayer from '@/components/vimeo/VimeoPlayer';

interface StoryPreviewProps {
  story: Partial<Story>;
}

const StoryPreview: React.FC<StoryPreviewProps> = ({ story }) => {
  return (
    <div className="bg-card rounded-lg shadow-md p-6">
      <div className="aspect-w-16 aspect-h-9 mb-6 rounded-lg overflow-hidden">
        <img 
          src={story.coverImage} 
          alt={story.title} 
          className="w-full h-full object-cover"
        />
      </div>
      <h1 className="text-3xl font-bold mb-2 font-gt-super">{story.title}</h1>
      <h2 className="text-xl text-muted-foreground mb-4 font-gt-super">{story.subtitle}</h2>
      
      <div className="flex items-center space-x-4 mb-6">
        <div className="flex items-center space-x-2">
          <div className="h-10 w-10 rounded-full overflow-hidden">
            <img 
              src={story.author?.avatar} 
              alt={story.author?.name} 
              className="h-full w-full object-cover"
            />
          </div>
          <div>
            <p className="font-medium">{story.author?.name}</p>
            <p className="text-sm text-muted-foreground">
              {new Date(story.publishedAt || "").toLocaleDateString()} 
              • {Math.ceil((story.content?.length || 0) / 1000)} min read
            </p>
          </div>
        </div>
      </div>
      
      <div className="flex flex-wrap gap-2 mb-6">
        <span className="px-3 py-1 bg-secondary text-secondary-foreground rounded-full text-sm">
          {story.category}
        </span>
        {story.tags?.map((tag, index) => (
          <span key={index} className="px-3 py-1 bg-secondary/50 text-secondary-foreground rounded-full text-sm">
            {tag}
          </span>
        ))}
      </div>
      
      <p className="text-lg font-medium italic mb-8">{story.excerpt}</p>
      
      {story.vimeo && (
        <div className="my-8">
          <VimeoPlayer
            vimeoId={story.vimeo}
            title={story.title as string}
            minHeight="400px"
            responsive={true}
          />
        </div>
      )}
      
      <div className="prose dark:prose-invert max-w-none">
        {story.content?.split('\n').map((paragraph, index) => (
          <p key={index} className="mb-4">{paragraph}</p>
        ))}
      </div>
    </div>
  );
};

export default StoryPreview;
